export class RoleAccessGroupCondition {
    'operator';
    'operands';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "LogicalOperator",
            "format": ""
        },
        {
            "name": "operands",
            "baseName": "operands",
            "type": "Array<AccessConditionalExpression>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RoleAccessGroupCondition.attributeTypeMap;
    }
    constructor() {
    }
}
